import { render, staticRenderFns } from "./checkAccept.vue?vue&type=template&id=d53486a8&scoped=true&"
import script from "./checkAccept.vue?vue&type=script&lang=js&"
export * from "./checkAccept.vue?vue&type=script&lang=js&"
import style0 from "./checkAccept.vue?vue&type=style&index=0&id=d53486a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53486a8",
  null
  
)

export default component.exports